import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BornToDominate() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="born-to-dominate" className="dark bg-background text-foreground relative h-screen w-full overflow-hidden grid grid-cols-1 md:grid-cols-12 items-center">
      {}
      <div className="absolute inset-0 md:relative md:col-span-7 h-full z-0 overflow-hidden">
        <img src="https://djtaurx.com/wp-content/uploads/2026/02/Untitled-design-1.png" alt="High contrast concert crowd with DJ Taurx performing" className="h-full w-full object-cover object-center grayscale-[20%] contrast-125 transition-transform duration-[2000ms] scale-105 !text-[hsl(214,32%,91%)] ![margin:0px_0px_6px_0px] hover:scale-100" />
        {}
        <div className="absolute inset-0 bg-black/60 ![margin:8px_0px_1px_0px] md:bg-gradient-to-r md:from-transparent md:to-black/80" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 md:col-span-5 px-6 md:px-12 lg:px-20 flex flex-col items-start text-left transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
        <div className="w-full max-w-xl !text-[hsl(0,0%,100%)]">
          <h1 className="font-serif text-6xl font-bold leading-[0.9] tracking-tighter drop-shadow-2xl !text-[hsl(50,98%,64%)] md:text-7xl lg:text-8xl xl:text-9xl">
            DJ <br />
            TAURX
          </h1>
          <div className="h-1 w-24 mt-8 mb-6 !bg-[hsl(43,96%,56%)] !text-[hsl(0,0%,100%)]" />
          <p className="font-sans text-base uppercase tracking-[0.5em] font-semibold drop-shadow-lg !text-[hsl(0,0%,100%)] md:text-lg lg:text-xl">
            Born to dominate
          </p>
        </div>
      </div>
    </section>;
}